export const globalDebug = () => {
  if (!process.env.DEBUG_INFO_ENABLED) {
    console.log = () => undefined;
    console.info = () => undefined;
    console.debug = () => undefined;
  }
};

export const getDocumentPathFromOfferSku = offerSku => {
  return offerSku
    .split('_')
    .slice(0, 2)
    .join('_C/');
};

export const getDocumentPathFromProductCode = productCode => {
  return productCode +'_C';
};

export const scrollToNextSection = target => {
  target.current.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
    inline: 'nearest'
  });
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const setStylesProperties = (data: any): any => {
  document.documentElement.style.setProperty('--active-field-background-color', data.activeFieldBackgroundColor);
  document.documentElement.style.setProperty('--background-color', data.backgroundColor);
  document.documentElement.style.setProperty('--background-image', 'url(' + data.backgroundImage + ') no-repeat top center');
  document.documentElement.style.setProperty('--clickable-color', data.clickableColor);
  document.documentElement.style.setProperty('--button-color', data.buttonColor);
  document.documentElement.style.setProperty('--fail-color', data.failColor);
  document.documentElement.style.setProperty('--field-information-color', data.fieldInformationColor);
  document.documentElement.style.setProperty('--form-background-color', data.formBackgroundColor);
  document.documentElement.style.setProperty('--hover-main-clickable-color', data.hoverMainClickableColor);
  document.documentElement.style.setProperty('--hover-secondary-clickable-color', data.hoverSecondaryClickableColor);
  document.documentElement.style.setProperty('--information-color', data.informationColor);
  document.documentElement.style.setProperty('--panel-opened-color', data.panelOpenedColor);
  document.documentElement.style.setProperty('--primary-color', data.primaryColor);
  document.documentElement.style.setProperty('--primary-client', data.primaryColor);
  document.documentElement.style.setProperty('--primary-fushia', data.primaryColor);
  document.documentElement.style.setProperty('--success-color', data.successColor);
  document.documentElement.style.setProperty('--text-color', data.textColor);
  document.documentElement.style.setProperty('--warning-color', data.warningColor);
  document.documentElement.style.setProperty('--secondary-client-light', data.hoverSecondaryClickableColor);

  return Promise.resolve();
};

export const formatText = (text: string) => {
  while (/\s/.test(text)) {
    const index = /\s/.exec(text);
    text = text.substring(0, index['index']) + ';' + text.substring(index['index'] + 1);
  }
  return text.replace(/;/g, ' ');
};

export const countriesList = [
  { value: 'FR', name: 'FRANCE' },
  { value: 'AF', name: 'AFGHANISTAN' },
  { value: 'ZA', name: 'AFRIQUE DU SUD' },
  { value: 'AL', name: 'ALBANIE' },
  { value: 'DZ', name: 'ALGERIE' },
  { value: 'DE', name: 'ALLEMAGNE' },
  { value: 'AD', name: 'ANDORRE' },
  { value: 'AO', name: 'ANGOLA' },
  { value: 'AG', name: 'ANTIGUA-ET-BARBUDA' },
  { value: 'AN', name: 'ANTILLES NEERLANDAISES' },
  { value: 'SA', name: 'ARABIE SAOUDITE' },
  { value: 'AR', name: 'ARGENTINE' },
  { value: 'AM', name: 'ARMENIE' },
  { value: 'AU', name: 'AUSTRALIE' },
  { value: 'AT', name: 'AUTRICHE' },
  { value: 'AZ', name: 'AZERBAIDJAN' },
  { value: 'BS', name: 'BAHAMAS' },
  { value: 'BH', name: 'BAHREIN' },
  { value: 'BD', name: 'BANGLADESH' },
  { value: 'BB', name: 'BARBADE' },
  { value: 'BY', name: 'BELARUS' },
  { value: 'BE', name: 'BELGIQUE' },
  { value: 'BZ', name: 'BELIZE' },
  { value: 'BJ', name: 'BENIN' },
  { value: 'BM', name: 'BERMUDES' },
  { value: 'BT', name: 'BHOUTAN' },
  { value: 'BO', name: 'BOLIVIE' },
  { value: 'BA', name: 'BOSNIE-HERZEGOVINE' },
  { value: 'BW', name: 'BOTSWANA' },
  { value: 'BR', name: 'BRESIL' },
  { value: 'BN', name: 'BRUNEI DARUSSALAM' },
  { value: 'BG', name: 'BULGARIE' },
  { value: 'BF', name: 'BURKINA FASO' },
  { value: 'BI', name: 'BURUNDI' },
  { value: 'KH', name: 'CAMBODGE' },
  { value: 'CM', name: 'CAMEROUN' },
  { value: 'CA', name: 'CANADA' },
  { value: 'CV', name: 'CAP-VERT' },
  { value: 'CF', name: 'CENTRAFRICAINE, REPUBL.' },
  { value: 'CL', name: 'CHILI' },
  { value: 'CN', name: 'CHINE' },
  { value: 'CY', name: 'CHYPRE' },
  { value: 'CO', name: 'COLOMBIE' },
  { value: 'KM', name: 'COMORES' },
  { value: 'CG', name: 'CONGO (BRAZZA)' },
  { value: 'CD', name: 'CONGO (ZAIRE)' },
  { value: 'CK', name: 'COOK, ILES' },
  { value: 'KP', name: 'COREE DU NORD' },
  { value: 'KR', name: 'COREE DU SUD' },
  { value: 'CR', name: 'COSTA RICA' },
  { value: 'CI', name: "COTE D'IVOIRE" },
  { value: 'HR', name: 'CROATIE' },
  { value: 'CU', name: 'CUBA' },
  { value: 'DK', name: 'DANEMARK' },
  { value: 'DJ', name: 'DJIBOUTI' },
  { value: 'DO', name: 'DOMINICAINE, REPUBL.' },
  { value: 'DM', name: 'DOMINIQUE' },
  { value: 'EG', name: 'EGYPTE' },
  { value: 'SV', name: 'EL SALVADOR' },
  { value: 'AE', name: 'EMIRATS ARABES UNIS' },
  { value: 'EC', name: 'EQUATEUR' },
  { value: 'ER', name: 'ERYTHREE' },
  { value: 'ES', name: 'ESPAGNE' },
  { value: 'EE', name: 'ESTONIE' },
  { value: 'US', name: 'ETATS-UNIS' },
  { value: 'ET', name: 'ETHIOPIE' },
  { value: 'FJ', name: 'FIDJI' },
  { value: 'FI', name: 'FINLANDE' },
  { value: 'GA', name: 'GABON' },
  { value: 'GM', name: 'GAMBIE' },
  { value: 'GE', name: 'GEORGIE' },
  { value: 'GH', name: 'GHANA' },
  { value: 'GI', name: 'GIBRALTAR' },
  { value: 'GB', name: 'GRANDE-BRETAGNE' },
  { value: 'GR', name: 'GRECE' },
  { value: 'GD', name: 'GRENADE' },
  { value: 'GU', name: 'GUAM' },
  { value: 'GT', name: 'GUATEMALA' },
  { value: 'GN', name: 'GUINEE' },
  { value: 'GW', name: 'GUINEE-BISSAU' },
  { value: 'GQ', name: 'GUINEE EQUATORIALE' },
  { value: 'GY', name: 'GUYANA' },
  { value: 'HT', name: 'HAITI' },
  { value: 'HN', name: 'HONDURAS' },
  { value: 'HK', name: 'HONG-KONG' },
  { value: 'HU', name: 'HONGRIE' },
  { value: 'IN', name: 'INDE' },
  { value: 'ID', name: 'INDONESIE' },
  { value: 'IR', name: 'IRAN' },
  { value: 'IQ', name: 'IRAQ' },
  { value: 'IE', name: 'IRLANDE' },
  { value: 'IS', name: 'ISLANDE' },
  { value: 'IL', name: 'ISRAEL' },
  { value: 'IT', name: 'ITALIE' },
  { value: 'JM', name: 'JAMAIQUE' },
  { value: 'JP', name: 'JAPON' },
  { value: 'JO', name: 'JORDANIE' },
  { value: 'KZ', name: 'KAZAKHSTAN' },
  { value: 'KE', name: 'KENYA' },
  { value: 'KG', name: 'KIRGHIZISTAN' },
  { value: 'KI', name: 'KIRIBATI' },
  { value: 'KW', name: 'KOWEIT' },
  { value: 'LA', name: 'LAOS' },
  { value: 'LS', name: 'LESOTHO' },
  { value: 'LV', name: 'LETTONIE' },
  { value: 'LB', name: 'LIBAN' },
  { value: 'LR', name: 'LIBERIA' },
  { value: 'LY', name: 'LIBYE' },
  { value: 'LI', name: 'LIECHTENSTEIN' },
  { value: 'LT', name: 'LITUANIE' },
  { value: 'LU', name: 'LUXEMBOURG' },
  { value: 'MO', name: 'MACAO' },
  { value: 'MK', name: 'MACEDOINE' },
  { value: 'MG', name: 'MADAGASCAR' },
  { value: 'MY', name: 'MALAISIE' },
  { value: 'MW', name: 'MALAWI' },
  { value: 'MV', name: 'MALDIVES' },
  { value: 'ML', name: 'MALI' },
  { value: 'MT', name: 'MALTE' },
  { value: 'MA', name: 'MAROC' },
  { value: 'MH', name: 'MARSHALL, ILES' },
  { value: 'MU', name: 'MAURICE' },
  { value: 'MR', name: 'MAURITANIE' },
  { value: 'MX', name: 'MEXIQUE' },
  { value: 'FM', name: 'MICRONESIE' },
  { value: 'MD', name: 'MOLDAVIE' },
  { value: 'MC', name: 'MONACO' },
  { value: 'MN', name: 'MONGOLIE' },
  { value: 'MZ', name: 'MOZAMBIQUE' },
  { value: 'MM', name: 'MYANMAR (BIRMANIE)' },
  { value: 'NA', name: 'NAMIBIE' },
  { value: 'NR', name: 'NAURU' },
  { value: 'NP', name: 'NEPAL' },
  { value: 'NI', name: 'NICARAGUA' },
  { value: 'NE', name: 'NIGER' },
  { value: 'NG', name: 'NIGERIA' },
  { value: 'NU', name: 'NIUE' },
  { value: 'NO', name: 'NORVEGE' },
  { value: 'NZ', name: 'NOUVELLE-ZELANDE' },
  { value: 'OM', name: 'OMAN' },
  { value: 'UG', name: 'OUGANDA' },
  { value: 'UZ', name: 'OUZBEKISTAN' },
  { value: 'PK', name: 'PAKISTAN' },
  { value: 'PW', name: 'PALAOS' },
  { value: 'PA', name: 'PANAMA' },
  { value: 'PG', name: 'PAPOUASIE-NOUV.-GUINEE' },
  { value: 'PY', name: 'PARAGUAY' },
  { value: 'NL', name: 'PAYS-BAS' },
  { value: 'PE', name: 'PEROU' },
  { value: 'PH', name: 'PHILIPPINES' },
  { value: 'PL', name: 'POLOGNE' },
  { value: 'PR', name: 'PORTO RICO' },
  { value: 'PT', name: 'PORTUGAL' },
  { value: 'QA', name: 'QATAR' },
  { value: 'RO', name: 'ROUMANIE' },
  { value: 'RU', name: 'RUSSIE' },
  { value: 'RW', name: 'RWANDA' },
  { value: 'LC', name: 'SAINTE-LUCIE' },
  { value: 'KN', name: 'SAINT-KITTS-ET-NEVIS' },
  { value: 'SM', name: 'SAINT-MARIN' },
  { value: 'VC', name: 'SAINT-VINCENT' },
  { value: 'SB', name: 'SALOMON, ILES' },
  { value: 'WS', name: 'SAMOA' },
  { value: 'ST', name: 'SAO TOME-ET-PRINCIPE' },
  { value: 'SN', name: 'SENEGAL' },
  { value: 'CS', name: 'SERBIE-ET-MONTENEGRO' },
  { value: 'SC', name: 'SEYCHELLES' },
  { value: 'SL', name: 'SIERRA LEONE' },
  { value: 'SG', name: 'SINGAPOUR' },
  { value: 'SK', name: 'SLOVAQUIE' },
  { value: 'SI', name: 'SLOVENIE' },
  { value: 'SO', name: 'SOMALIE' },
  { value: 'SD', name: 'SOUDAN' },
  { value: 'LK', name: 'SRI LANKA' },
  { value: 'SE', name: 'SUEDE' },
  { value: 'CH', name: 'SUISSE' },
  { value: 'SR', name: 'SURINAME' },
  { value: 'SZ', name: 'SWAZILAND' },
  { value: 'SY', name: 'SYRIE' },
  { value: 'TJ', name: 'TADJIKISTAN' },
  { value: 'TW', name: 'TAIWAN' },
  { value: 'TZ', name: 'TANZANIE' },
  { value: 'TD', name: 'TCHAD' },
  { value: 'CZ', name: 'TCHEQUIE' },
  { value: 'TH', name: 'THAILANDE' },
  { value: 'TL', name: 'TIMOR-LESTE' },
  { value: 'TG', name: 'TOGO' },
  { value: 'TO', name: 'TONGA' },
  { value: 'TT', name: 'TRINITE-ET-TOBAGO' },
  { value: 'TN', name: 'TUNISIE' },
  { value: 'TM', name: 'TURKMENISTAN' },
  { value: 'TR', name: 'TURQUIE' },
  { value: 'TV', name: 'TUVALU' },
  { value: 'UA', name: 'UKRAINE' },
  { value: 'UY', name: 'URUGUAY' },
  { value: 'VU', name: 'VANUATU' },
  { value: 'VA', name: 'VATICAN' },
  { value: 'VE', name: 'VENEZUELA' },
  { value: 'VN', name: 'VIET NAM' },
  { value: 'YE', name: 'YEMEN' },
  { value: 'ZM', name: 'ZAMBIE' },
  { value: 'ZW', name: 'ZIMBABWE' }
];

export const getCountryNameByValue = (value: string) => {
  const country = countriesList.find(c => c.value === value);
  return country ? country.name : null;
};

export const customerWSTARIFMap: Record<string, number> = {
  firstCustomer: 1, // adhérent
  secondCustomer: 2, // conjoint
  secondCustomerOnly: 3 // conjoint seul
};

export const toRecordStringStringArray = (obj: Record<string, unknown>): Record<string, string | string[]> => {
  const result: Record<string, string | string[]> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string' || Array.isArray(value)) {
      result[key] = value;
    } else {
      result[key] = '';
    }
  }
  return result;
};

export const getFirstNameString = (firstNames: string | string[]) => {
  if (Array.isArray(firstNames)) {
    return firstNames.join(', ');
  }
  return firstNames || '';
};

export const civilityMap = {
  Monsieur: 'MR',
  Madame: 'MRS'
};

export const civilityMapMF = {
  Monsieur: 'MALE',
  Madame: 'FEMALE'
};

export const civilityLabelMap = {
  Monsieur: 'M.',
  Madame: 'Mme.'
};

export const capitalizeNamesAndCities = (text: string): string => {
  if (!text || typeof text !== 'string') return '';

  // Exceptions pour les particules et préfixes
  const lowercaseParticles = new Set(['de', 'd', 'des', 'du', 'à', 'aux', 'en']);
  const cityPrefixes = new Set(['saint', 'sainte', 'st', 'ste']);

  return text
    .toLowerCase()
    .split(/(\s+|[ '-])/) // Split sur espaces, apostrophes et traits d'union
    .map((segment, i, arr) => {
      if (!segment.trim()) return segment; // Préserve les espaces

      // Gestion spéciale des préfixes de villes
      if (cityPrefixes.has(segment)) {
        return i === 0 || arr[i - 1].trim() === '' ? 'Saint' + (segment.endsWith('e') ? 'e' : '') : segment;
      }

      // Règles générales
      return segment.replace(/(^|\s+|['-])(\w)/g, (match, prefix, letter) => {
        const isAfterParticle = lowercaseParticles.has(segment) && !prefix.endsWith("'");
        return isAfterParticle ? prefix + letter.toLowerCase() : prefix + letter.toUpperCase();
      });
    })
    .join('')
    .replace(/(\s)([dDlL][eEaAuxUXsS]?)(\s)/g, (match, s1, particle, s2) => s1 + particle.toLowerCase() + s2); // Post-correction des particules
};

export const formatDateToFrench = (isoDate?: string): string => {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.split('-');
  return `${day}/${month}/${year}`;
};

export const getFirstText = (richText: any): string => {
  return richText?.blocks?.[0]?.text || '';
};

export const extractDepartmentFromPostalCode = (postalCode: string): number | null => {
  if (!postalCode || postalCode.length < 2) return null;

  // Exclure les DOM-TOM
  // if (postalCode.startsWith('97') || postalCode.startsWith('98')) {
  //   return null;
  // }

  // Corse : 2A et 2B
  // if (postalCode.startsWith('20')) {
  //   const code = parseInt(postalCode.substring(0, 3), 10);
  //   return code < 202 ? 20 : 21; // 2A → 20, 2B → 21
  // }

  // Départements métropolitains
  return parseInt(postalCode.substring(0, 2), 10);
};

export const decodeHtml = (encodedString: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(encodedString, 'text/html');
  return doc.body.textContent || '';
};

export const mapCivility = (civility: string): 'Monsieur' | 'Madame' | '' => {
  const civilitymapper: { [key: string]: 'Monsieur' | 'Madame' | '' } = {
    Mr: 'Monsieur',
    Monsieur: 'Monsieur',
    Mme: 'Madame',
    Madame: 'Madame',
    Mrs: 'Madame',
  };
  return civilitymapper[civility] || '';
};

export const openBlobDocument = (blobUrl: string, filename: string) => {
  fetch(blobUrl)
    .then(response => response.blob())
    .then(blob => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, '_blank');
      if (!newWindow) {
        alert('Please allow popups for this website');
        return;
      }
      // Optional: Automatically revoke the object URL when the window unloads
      newWindow.onload = () => {
        URL.revokeObjectURL(url);
      };
    });
};

export const base64ToBlob = (base64: string, mimeType: string): Blob => {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return new Blob([bytes], { type: mimeType });
};

const isLikelyJwt = (value: string): boolean => {
  if (!value) return false;
  const parts = value.split('.');
  return parts.length === 3 && parts.every(part => part.length > 0);
};

export const persistSubscriptionTokenFromUrl = (subscriptionId?: string): string | null => {
  if (!subscriptionId) return null;

  const url = new URL(window.location.href);
  const urlToken = url.searchParams.get('token');
  if (!urlToken || !isLikelyJwt(urlToken)) return null;

  localStorage.setItem(`subscriptionToken_${subscriptionId}`, urlToken);

  url.searchParams.delete('token');
  const newUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, document.title, newUrl);

  return urlToken;
};


export const getSubscriptionToken = (subscriptionId: string): string => {
  const persistedTokenFromUrl = persistSubscriptionTokenFromUrl(subscriptionId);
  const token = persistedTokenFromUrl || localStorage.getItem(`subscriptionToken_${subscriptionId}`);
  if (!token) {
    throw new Error('Token de souscription non trouvé');
  }
  return token;
};


export const escapeHtml = (str: string): string => {
  return str?.replace(/<[^>]*>?/gm, '');
}

const extractApiError = (error: any) => {
  if (error?.return) {
    return error; // Déjà au bon format
  }

  if (error?.details?.[0]) {
    try {
      const jsonMatch = error.details[0].match(/\{.*\}/);
      return jsonMatch ? JSON.parse(jsonMatch[0]) : null;
    } catch (e) {
      return null;
    }
  }

  return null;
};

export const isDuplicateSubscriptionError = (error: any): boolean => {
  const apiError = extractApiError(error);
  return (
    apiError?.return?.status === "KO" &&
    apiError?.return?.error?.code === "409-000"
  );
};

 // Fonction pour déterminer si l'IBAN est français
 export const isFrenchIban = (ibanValue: string): boolean => {
  const cleanIban = ibanValue.replace(/\s/g, '');
  return cleanIban.startsWith('FR');
};

